import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	RepeatingSectionType,
	REPEAT_SECTION_TEMPLATE,
	REPEAT_SECTION_STYLES,
} from '../repeating-section.type';
import { NgIf, NgFor } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { FormlyModule } from '@ngx-formly/core';

@Component({
	selector: 'formly-repeat-additional-debt',
	template: REPEAT_SECTION_TEMPLATE,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: REPEAT_SECTION_STYLES,
	imports: [NgIf, MatIconButton, MatTooltip, MatIcon, NgFor, FormlyModule],
})
export class RepeatingAdditionalDebtType
	extends RepeatingSectionType
	implements OnInit
{
	ngOnInit(): void {
		// Let the modal trigger the actual removal of soft-deleted rows once the
		// save that persists their removal has gone through.
		this.props.purgeDeleted = () => this.purgeDeleted();
	}

	/**
	 * Actually remove rows marked for deletion. Called once their removal has
	 * been persisted (i.e. after a successful Update), so the list only drops a
	 * row when the change is safely saved.
	 */
	purgeDeleted(): void {
		if (!this.field.fieldGroup) {
			return;
		}

		for (let i = this.field.fieldGroup.length - 1; i >= 0; i--) {
			if (this.field.fieldGroup[i].model?._delete) {
				this.remove(i, { markAsDirty: false });
			}
		}
	}
}
